<template>
  <div class="pt-4">
    <div class="card-deck mb-4">
      <project-borrower-card />
      <user-relationship-manager heading="Borrower Relationship Manager" :user="project.user" />
    </div>
    <ul class="nav nav-pills nav-fill bg-light mb-4">
      <li class="nav-item">
        <router-link class="nav-link" exact :to="{ name: 'projects.dashboard', params: { id: project._id } }">
          Project
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="{ name: 'projects.dashboard.terms', params: { id: project._id } }">
          Terms
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="{ name: 'projects.dashboard.servicing', params: { id: project._id } }">
          Servicing
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="{ name: 'projects.dashboard.documents', params: { id: project._id } }">
          Documents
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="{ name: 'projects.dashboard.notes', params: { id: project._id } }">
          Notes
        </router-link>
      </li>
    </ul>
    <template v-if="active === 'project'">
      <div class="card-deck mb-4">
        <project-details-card />
        <project-financials-card />
      </div>
      <project-funding />
      <template v-if="available">
        <project-loan-assessment v-if="project.facility" :facility="facility" />
        <project-securities :facility="facility"/>
        <!-- TODO <project-credit-paper /> -->
        <project-qs />
        <project-valuer />
        <project-solicitor />
      </template>
    </template>
    <template v-if="active === 'terms'">
      <project-terms />
    </template>
    <template v-if="active === 'servicing'">
      <template v-if="project.facility">
        <facility-projection />
        <project-security-breakdown :facility="facility"/>
      </template>
      <template v-else>
        <p class="text-center">
          No terms set yet.
        </p>
      </template>
    </template>
    <template v-if="active === 'documents'">
      <project-documents />
    </template>
    <template v-if="active === 'notes'">
      <project-notes />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Facility } from '@saxon-trust/facility-modelling'

import FacilityProjection from './FacilityProjection.vue'
import FacilitySchedule from './FacilitySchedule.vue'
import ProjectBorrowerCard from './ProjectBorrowerCard.vue'
import ProjectCreditPaper from './ProjectCreditPaper.vue'
import ProjectDetailsCard from './ProjectDetailsCard.vue'
import ProjectDocuments from './ProjectDocuments.vue'
import ProjectFinancialsCard from './ProjectFinancialsCard.vue'
import ProjectFunding from './ProjectFunding.vue'
import ProjectLoanAssessment from './ProjectLoanAssessment.vue'
import ProjectNotes from './ProjectNotes.vue'
import ProjectQs from './ProjectQs.vue'
import ProjectSecurities from './ProjectSecurities.vue'
import ProjectSecurityBreakdown from './ProjectSecurityBreakdown.vue'
import ProjectSolicitor from './ProjectSolicitor.vue'
import ProjectTerms from './ProjectTerms.vue'
import ProjectValuer from './ProjectValuer.vue'
import UserRelationshipManager from './UserRelationshipManager.vue'

export default {
  created () {
    this.calculateFacility()

    if (this.$route.meta.tab) {
      this.active = this.$route.meta.tab
    }
  },

  data: () => ({
    active: 'project',
    facility: null
  }),

  name: 'ProjectAdminDashboard',

  components: {
    FacilityProjection,
    FacilitySchedule,
    ProjectBorrowerCard,
    ProjectCreditPaper,
    ProjectDetailsCard,
    ProjectDocuments,
    ProjectFinancialsCard,
    ProjectFunding,
    ProjectLoanAssessment,
    ProjectNotes,
    ProjectQs,
    ProjectSecurities,
    ProjectSecurityBreakdown,
    ProjectSolicitor,
    ProjectTerms,
    ProjectValuer,
    UserRelationshipManager
  },

  computed: {
    available () {
      const mainStepsCompleted = this.project.stages.details && this.project.stages.financials

      if (this.$auth.admin()) {
        return mainStepsCompleted
      }

      return mainStepsCompleted && this.project.stages.funding
    },

    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    calculateFacility () {
      if (this.project.facility) {
        this.facility = new Facility(this.project.facility)
        this.facility.calculate()
      }
    }
  },

  watch: {
    $route: {
      deep: true,
      handler () {
        if (this.$route.meta.tab) {
          this.active = this.$route.meta.tab
        }
      }
    },

    project: {
      deep: true,
      handler () {
        this.calculateFacility()
      }
    }
  }
}
</script>
